import { undefinedOrTransformToDTOCurried } from '@maia/utils';
import { IBrokerEntity } from '../entitites/broker.entity';

export class BrokerDto {
  readonly guid: string;
  readonly initials: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly email: string;
  readonly phone: string;
  readonly salesChannel: string;

  constructor(broker: IBrokerEntity) {
    this.guid = broker.guid;
    this.initials = broker.initials;
    this.firstName = broker.first_name;
    this.lastName = broker.last_name;
    this.email = broker.email;
    this.phone = broker.phone;
    this.salesChannel = broker.sales_channel;
  }
}

export const undefinedOrBroker = undefinedOrTransformToDTOCurried(
  (entity: IBrokerEntity) => new BrokerDto(entity),
);
